import ReportDocument from "./ReportDocument";

const MISExpenses = ({ data = [] }) => {
  const columns = [
    { label: "Transaction ID", key: "transaction_number" },
    { label: "Merchant Name", key: "merchant" },
    { label: "Employee Name", key: "employee_name" },
    { label: "Category", key: "category" },
    { label: "Report ID", key: "report_number" },
    { label: "Report Name", key: "report_name" },
    { label: "Transaction Date", key: "transaction_date" },
    { label: "Submitted On", key: "report_submitted_on" },
    { label: "Amount", key: "transaction_amount" },
  ];

  const customFields = data[0]?.custom_fields?.map((ele) => ele.key) ?? [];

  return (
    <ReportDocument columns={columns} data={data} customFields={customFields} />
  );
};

export default MISExpenses;
